module.exports = __webpack_public_path__ + "img/yue.20958700.png";